export default "__VITE_ASSET__C_El$91___"